<template>
  <article class="post">
    <div class="post__image" v-if="post.thumbnail">
      <a
        :href="post.permalink"
        :title="post.post_title"
        v-html="post.thumbnail"
      >
      </a>
    </div>

    <div class="post__inner typography">
      <h2 class="post__inner__title">
        <a
          :href="post.permalink"
          :title="post.post_title"
          v-html="post.post_title"
        >
        </a>
      </h2>
      <p class="post__inner__meta">
        <a :href="post.permalink" :title="post.post_title">
          {{ post.post_type_title }}
        </a>
        <time datetime="#">{{ post.post_date_formatted }}</time>
      </p>
    </div>
  </article>
</template>

<script>
export default {
  name: "NewsPost",
  props: ["post"]
};
</script>

<style scoped></style>
